import React from 'react'
import { Link } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import styled from 'styled-components'
import Typography from '@/v2/components/common/Typography'
import MenuItem from '@mui/material/MenuItem'

const LinkWithoutStyle = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.primary.main};
`

const ExternalLinkWithoutStyle = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.primary.main};
`

const Option = ({ label, onClick }) => {
  const theme = useTheme()
  return (
    <MenuItem key={label} onClick={onClick}>
      <Typography fontSize="14px" color={theme.palette.black.main}>
        {label}
      </Typography>
    </MenuItem>
  )
}

const isExternalUrl = href => {
  if (!href) return false
  const url = typeof href === 'string' ? href : href.pathname
  return url && (url.startsWith('http://') || url.startsWith('https://'))
}

const getHrefUrl = href => {
  if (typeof href === 'string') return href
  return href?.pathname || href
}

const GalleryOption = ({ label, href, target, onClick }) => {
  const theme = useTheme()

  if (!href) {
    return <Option label={label} onClick={onClick} />
  }

  if (isExternalUrl(href)) {
    return (
      <ExternalLinkWithoutStyle
        theme={theme.palette}
        href={getHrefUrl(href)}
        target={target || '_blank'}
        rel="noopener noreferrer"
      >
        <Option label={label} onClick={onClick} />
      </ExternalLinkWithoutStyle>
    )
  }

  return (
    <LinkWithoutStyle
      theme={theme.palette}
      to={href}
      target={target || '_self'}
      rel="noopener noreferrer"
    >
      <Option label={label} onClick={onClick} />
    </LinkWithoutStyle>
  )
}

export default GalleryOption
